import { translation } from '@/plugins/i18n';
// import { transferMoney } from 'common/utils';
import trackings from '@/aspects/trackings';
import cookies from 'js-cookie';
import query from 'query-string';
import _ from "lodash";
import { transferMoney } from "@/utils/money";
import { getCurrency } from '@/utils/currency';
import { flowTypes, pageConfig } from '@/common/service/page-config';
import { routePathMap } from '@/router';
import Loading from '@zoom/zoom-ui/src/components/loading';
import globalEventBus from '@/common/global-event-bus';
import { isMobile, isTablet, isDesktop } from '@/utils/responsive';
import customZmSelectDropdown from './custom-zm-select-dropdown';

let loader;

export const $query = query.parse(location.search);

export const $tracking = trackings;

export const $config = (key, def) => {
    return _.get(pageConfig || {}, key, def);
};

export let $context;

export const $cookie = cookies.withConverter({
    write: function (value) {
        return value;
    },
    read: cookies.converter.read,
});

export default {
    install(Vue) {
        customZmSelectDropdown(Vue);

        Vue.prototype.$t = translation;

        Vue.prototype.$tracking = $tracking;

        Vue.prototype.$query = window.$query = $query;

        Vue.prototype.$cookie = window.$cookie = $cookie;

        Vue.prototype.$loading = window.$loading = (is = true) => {
            if (is) {
                let text = '';
                if (typeof is === 'string') {
                    text = is;
                }
                loader && loader.close();
                loader = Loading.service({
                    lock: true,
                    text,
                    customClass: 'opc-global-loading',
                })
            } else if (is === false) {
                loader.close();
            }
        };

        Vue.prototype.$config = window.$config = $config;

        Vue.prototype.$money = window.$money = transferMoney;

        $context = {
            flow: pageConfig.type, // flow type
            type: pageConfig?.editConfig?.planType, // current config plan type
            currency: getCurrency(),
            $on: globalEventBus.$on.bind(globalEventBus),
            $off: globalEventBus.$off.bind(globalEventBus),
            $emit: globalEventBus.$emit.bind(globalEventBus),
            is: {
                // responsive mobile/tablet/desktop
                mobile: isMobile,
                tablet: isTablet,
                desktop: isDesktop,
                // session
                loggedIn: window.SB?.loggedIn ?? false,
                // page mode
                embedded: false, // launched in iframe or modal
                // flow
                buyNow: pageConfig.type === flowTypes.buyNow,
                // FREE TRIAL
                add2trial: pageConfig.type === flowTypes.add2trial,
                // BUY TRIAL
                buyTrial: pageConfig.type === flowTypes.buyTrial,
                add2cart: pageConfig.type === flowTypes.add2cart,
                basic2pro: pageConfig.type === flowTypes.basic2pro,
                pro2biz: pageConfig.type === flowTypes.pro2biz,
                edit: pageConfig.type === flowTypes.edit,
                upgrade: pageConfig.type === flowTypes.upgrade,
                downgrade: pageConfig.type === flowTypes.downgrade,
                trial2paid: pageConfig.type === flowTypes.trial2paid,
                mixBuy: pageConfig.type === flowTypes.mixBuy,
                biz2bundle: pageConfig.type === flowTypes.biz2bundle,
                prop2bundle: pageConfig.type === flowTypes.prop2bundle,
                pro2prop: pageConfig.type === flowTypes.pro2prop,
                /* functions will be rewritten as getter, see ref0 */
                // account
                withCC: () => Vue.__rootApp__?.$store.getters.withCcAccount,
                bulkLicense: () => Vue.__rootApp__?.$store.getters.basicConfig?.isBulkLicenseAccount,
                // router
                configPage: () => Vue.__rootApp__?.$router.currentRoute?.path === routePathMap.config,
                checkoutPage: () => Vue.__rootApp__?.$router.currentRoute?.path === routePathMap.checkout,
                editPage: () => Vue.__rootApp__?.$router.currentRoute?.path === routePathMap.edit,
                addPage: () => Vue.__rootApp__?.$router.currentRoute?.path === routePathMap.add,
            },
        };

        Object.keys($context.is).forEach(key => {
            // ref0
            if (typeof $context.is[key] === 'function') {
                Object.defineProperty($context.is, key, { get: $context.is[key] });
            }
        });

        Vue.prototype.$context = window.$context = $context;
    }
};
